import { TFunction } from 'i18next';
import moment from 'moment';
import { AbsenceOverlappingType } from '../../__generated__/graphql';
import { DayTime } from './types';

export function getOverlappingMessage(
  t: TFunction,
  overlappingType: AbsenceOverlappingType | undefined,
  hasOverlappingAbsences: boolean,
): string | undefined {
  if (!hasOverlappingAbsences || !overlappingType) {
    return undefined;
  }

  switch (overlappingType) {
    case AbsenceOverlappingType.NotAllowed:
      return t('requestAbsence.errors.overlappingAbsences.notAllowed');
    case AbsenceOverlappingType.Allowed:
      return t('requestAbsence.errors.overlappingAbsences.allowed');
    case AbsenceOverlappingType.AllowedWithOverride:
      return t('requestAbsence.errors.overlappingAbsences.allowedWithOverride');
    default:
      return undefined;
  }
}

export type DocumentUploadMode = 'hidden' | 'optional' | 'required';

type DocumentUploadModeParams = {
  // From the absence category.
  allowDocumentUpload: boolean;
  // From the request policy.
  requireDocumentUpload: boolean;
  minAmountForDocumentUpload: number | null;
  requestedAmount?: number | null;
};

export function getDocumentUploadMode({
  allowDocumentUpload,
  requireDocumentUpload,
  minAmountForDocumentUpload,
  requestedAmount,
}: DocumentUploadModeParams): DocumentUploadMode {
  // While the requested amount is unknown (validation in flight) we cannot
  // claim the threshold is met yet.
  const meetsPolicyThreshold =
    !minAmountForDocumentUpload ||
    (requestedAmount != null && requestedAmount >= minAmountForDocumentUpload);

  if (requireDocumentUpload && meetsPolicyThreshold) {
    return 'required';
  }

  return allowDocumentUpload ? 'optional' : 'hidden';
}

export function calculateDaysTimes(
  startDate: Date,
  endDate: Date,
  formValues: Record<string, any>,
): DayTime[] {
  const daysTimes: DayTime[] = [];
  const current = moment(startDate);
  const end = moment(endDate);

  while (current.isSameOrBefore(end, 'day')) {
    const date = current.format('YYYY-MM-DD');
    const start = formValues[`${date}_startTime`] || '09:00';
    const endT = formValues[`${date}_endTime`] || '17:00';
    daysTimes.push({
      currentDate: date,
      startTime: start,
      endTime: endT,
    });
    current.add(1, 'day');
  }

  return daysTimes;
}
